// COLORS PULLED FROM RC STYLE GUIDE
export const BLACK = '#000000';
export const WHITE = '#FFFFFF';
export const GRAY = '#B2B2B2';
export const NAVY = '#081C38';
export const GREEN = '#09312A';
export const CREAM = '#F4EEE7';
export const RED = '#EC104E';
export const PINK = '#FFF8F1';